import React from 'react';
// import logo from './logo.svg';
// import './App.css';
import RootReducer from './store';
import SnackbarContainer from './components/common/snackbar.container';
import RulesContainer from './components/rules/rules.container';
import SessionContainer from './components/session/session.container';
import SessionDetailContainer from './components/session/detail/sessionDetail.container';
import DocsComponent from './components/docs/docs.component';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Theme from './theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import {
  withAuthenticator,
  SignIn,
  Greetings,
  ConfirmSignIn,
  RequireNewPassword,
  VerifyContact,
  ForgotPassword
} from 'aws-amplify-react';

Amplify.configure(awsconfig);

/* eslint-disable no-underscore-dangle */
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
/* eslint-enable */

const store = createStore(
  RootReducer,
  composeEnhancer ? composeEnhancer(applyMiddleware(thunk)) : applyMiddleware(thunk),
);

function App() {
  return (
    <Provider store={store}>
    <MuiThemeProvider theme={Theme}>
    <CssBaseline />
    <SnackbarContainer />
    <BrowserRouter>
      <Switch>
        <Route exact path="/project/:sessionId" component={SessionDetailContainer} />
        <Route exact path="/project/:sessionId/file/:fileId" component={RulesContainer} />
        <Route exact path="/project/:sessionId/file/:fileId/:tab" component={RulesContainer} />
        <Route exact path="/" component={SessionContainer} />
        <Route exact path="/help" component={DocsComponent} />
      </Switch>
  </BrowserRouter>
  </MuiThemeProvider>
  </Provider>
  );
}

export default withAuthenticator(App, {usernameAttributes: "email", includeGreetings: true, includeGreetings: false}, [
  <Greetings />,
  <SignIn />,
  <ConfirmSignIn />,
  <VerifyContact />,
  <ForgotPassword />,
  <RequireNewPassword />
]);
